// extracted by mini-css-extract-plugin
module.exports = {"selectText":"style_selectText__25Ooq","delete":"style_delete__1Khmg","deleteButton":"style_deleteButton__3-px6","configurationTypes":"style_configurationTypes__3UD7j"};